export const DEFAULT_ADULTS = 2;
export const DEFAULT_CHILDREN_AGE = 6
export const DEFAULT_DATES_RANGE_DAYS = 2